import React from 'react';
import './PageStyle.css';

function PrivacyPolicy() {
  return (
    <div className="page-container">
      <h1>Privacy Policy</h1>
      <p>
        At IndoDefTech, we are committed to protecting your personal information and respecting your privacy.
      </p>
      <h3>Information We Collect</h3>
      <p>
        We may collect personal data such as your name, email, phone number, and other relevant details when 
        you contact us or use our services.
      </p>
      <h3>How We Use Your Information</h3>
      <p>
        Your information is used solely to provide, improve, and personalize our services, and to communicate 
        important updates or offers.
      </p>
      <h3>Data Protection</h3>
      <p>
        We use modern security technologies and measures to safeguard your information from unauthorized access 
        or disclosure.
      </p>
      <h3>Contact Us</h3>
      <p>
        For any questions or requests regarding our privacy policy, please contact us at 
        <strong> info@indodeftech.com</strong>.
      </p>
    </div>
  );
}

export default PrivacyPolicy;
